import React, { createContext, ReactNode, useEffect } from 'react'
import { LocalService, UserService } from '@src/domain/services'
import { userActions, useDispatch, useSelector } from '@src/store'
import { useAuth, useMutation } from '@src/hooks'

interface Permissions extends UserService.PagePermissionsBo {}

export interface PermissionsContextType {
  pagePermissions: Permissions | null;
  getPagePermissions: () => void
}

export const PermissionsContext = createContext<PermissionsContextType | undefined>(undefined);

export const PermissionsProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { pagePermissions } = useSelector(state => state.user)
  const dispatch = useDispatch()
  const token = LocalService.getToken()
  const { isAuthenticated } = useAuth()

  const { mutate: _getPagePermissions } = useMutation(UserService.getPagePermissions)

  const getPagePermissions = async () => {
    const pagePermissions = await _getPagePermissions()

    dispatch(
      userActions.setPagePermissions(pagePermissions)
    )
  }

  useEffect(() => {
    if (isAuthenticated) getPagePermissions()
  }
  , [token])

  return (
    <PermissionsContext.Provider value={{ pagePermissions, getPagePermissions }}>
      {children}
    </PermissionsContext.Provider>
  )
}

